export const parentData = [
  {
    key: "1",
    ParentImage: "assets/img/parents/parent-01.jpg",
    ChildImage: "assets/img/students/student-01.jpg",
    id: "PRT0001",
    name: "Thomas",
    Addedon: "Added on 25 Mar 2025",
    Child: "Janet",
    class: "Year 3, Jupiter",
    phone: "+6011 657 38589",
    email: "thomas@example.com",
  },
  {
    key: "2",
    ParentImage: "assets/img/parents/parent-02.jpg",
    ChildImage: "assets/img/students/student-02.jpg",
    id: "PRT0002",
    name: "Marquita",
    Addedon: "Added on 18 Mar 2025",
    Child: "Joann",
    class: "Year 4, Mars",
    phone: "+6011 479 58413",
    email: "marquita@example.com",
  },
  {
    key: "3",
    ParentImage: "assets/img/parents/parent-03.jpg",
    ChildImage: "assets/img/students/student-03.jpg",
    id: "PRT0003",
    name: "Johnson",
    Addedon: "Added on 14 Mar 2025",
    Child: "Kathleen",
    class: "Year 3, Jupiter",
    phone: "+6017 868 81745",
    email: "johnson@example.com",
  },
  {
    key: "4",
    ParentImage: "assets/img/parents/parent-04.jpg",
    ChildImage: "assets/img/students/student-04.jpg",
    id: "PRT0006",
    name: "Claudia",
    Addedon: "Added on 27 Feb 2025",
    Child: "Gifford",
    class: "I, Mars",
    phone: "+6011 723 23059",
    email: "claudia@example.com",
  },
  {
    key: "5",
    ParentImage: "assets/img/parents/parent-05.jpg",
    ChildImage: "assets/img/students/student-05.jpg",
    id: "PRT0001",
    name: "Arthur",
    Addedon: "Added on 11 Feb 2025",
    Child: "Lisa",
    class: "II, Mars",
    phone: "+6011 748 20482",
    email: "arthur@example.com",
  },
  {
    key: "6",
    ParentImage: "assets/img/parents/parent-06.jpg",
    ChildImage: "assets/img/students/student-06.jpg",
    id: "P124551",
    name: "Colleen",
    Addedon: "Added on 24 Jan 2025",
    Child: "Ralph",
    class: "Year 3, Mars",
    phone: "+6011 461 69472",
    email: "colleen@example.com",
  },
  {
    key: "7",
    ParentImage: "assets/img/parents/parent-07.jpg",
    ChildImage: "assets/img/students/student-07.jpg",
    id: "PRT0007",
    name: "Robert",
    Addedon: "Added on 19 Jan 2025",
    Child: "Julie",
    class: "V, Jupiter",
    phone: "+6011 449 90278",
    email: "robert@example.com",
  },
  {
    key: "8",
    ParentImage: "assets/img/parents/parent-08.jpg",
    ChildImage: "assets/img/students/student-08.jpg",
    id: "PRT0008",
    name: "Jessie",
    Addedon: "Added on 08 Jan 2025",
    Child: "Janet",
    class: "Year 3, Jupiter",
    phone: "+6011 846 34048",
    email: "jessie@example.com",
  },
  {
    key: "9",
    ParentImage: "assets/img/parents/parent-09.jpg",
    ChildImage: "assets/img/students/student-09.jpg",
    id: "PRT0009",
    name: "Michael",
    Addedon: "Added on 22 Mar 2025",
    Child: "Susan",
    class: "Year 8, Mars",
    phone: "+6011 910 38684",
    email: "michael@example.com",
  },
  {
    key: "10",
    ParentImage: "assets/img/parents/parent-10.jpg",
    ChildImage: "assets/img/students/student-10.jpg",
    id: "PRT0010",
    name: "Mary",
    Addedon: "Added on 15 Dec 2025",
    Child: "Richard",
    class: "Year 7, Mars",
    phone: "+6011 358 35718",
    email: "mary@example.com",
  },
  {
    key: "11",
    ParentImage: "assets/img/parents/parent-11.jpg",
    ChildImage: "assets/img/students/student-11.jpg",
    id: "PRT0011",
    name: "Edwin",
    Addedon: "Added on 10 Dec 2024",
    Child: "Veronica",
    class: "Year 9, Jupiter",
    phone: "+6011 657 38589",
    email: "edw@example.com",
  },
];
